import {
    postUploadFile,
    postDownloadFile,
    getGetFiles
} from '@/services/siesa-tips/service'

const state = () => ({
    files: [],
    errors: []
})

const mutations = {
    SET_DATA (state, data = []) {
        state.files = data
    },
    SET_ERROR (state, errors = []) {
        state.errors = errors
    },
    ADD_TO_DATA (state, file = {} ) {
        state.files.push(file)
    }
}
const actions = {
    async getGetFiles ({ commit }, query = {}) {
        const { success, result } = await getGetFiles(query)
        if (success) {
            commit("SET_ERROR")
            commit("SET_DATA", result)
        }
    },
    async uploadFile ({ commit }, file = {}) {
        const { success, result , error } = await postUploadFile(file)
        if (error) { commit("SET_ERROR", error.detail) }
        if (success) {
            commit("SET_ERROR")
            commit("ADD_TO_DATA", result)
        }
    },
    async downloadFile ({ commit }, {file_id = "", name = "file.xls"}) {
        const response = await postDownloadFile(file_id)
        const downloadElement = document.createElement('a')
        downloadElement.href = window.URL.createObjectURL(new Blob([response]))
        downloadElement.download = `${name}`
        document.body.appendChild(downloadElement)
        downloadElement.click()
        window.URL.revokeObjectURL(downloadElement.href)
        return commit
    }
}
const getters = {
    getFiles: (state) => {
        return state.files
    },
    getErrors: (state) => {
        return state.errors
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}


